import { useSpring, animated } from '@react-spring/web';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { borderRadius } from '../theme/border-radius';
import { shadow } from '../theme/shadow';
const StyledBadge = styled(animated.span) `
  padding: 2px 6px;
  border-radius: ${(props) => `${props.shape === 'square' ? borderRadius.sm : borderRadius.lg}`};
  line-height: 14px;
  font-size: 11px;
  box-shadow: ${(props) => props.shadow && shadow[props.shadow]};
  background-color: ${(props) => props.type === 'primary' ? 'var(--primary)' : 'var(--bg-color-1)'};
  color: ${(props) => props.type === 'primary' ? 'var(--primary-text-color)' : 'var(--text-color-0)'};
  display: inline-block;
`;
export const Badge = (props) => {
    var _a;
    const [styles, set] = useSpring(() => { var _a; return ({ count: (_a = props.count) !== null && _a !== void 0 ? _a : 0 }); });
    useEffect(() => {
        if (!props.animated) {
            return;
        }
        set({ count: props.count });
    }, [props.animated, props.count]);
    return (React.createElement(StyledBadge, { className: props.className, "data-role": "badge", onClick: props.onClick, type: props.type, shape: props.shape, shadow: props.shadow }, props.children || ((_a = styles.count) === null || _a === void 0 ? void 0 : _a.to((x) => x.toFixed(0)))));
};
